import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { NotFound } from 'secondstep-components'
import { toTitleCase } from 'utils/stringHelpers'
import BackLink from 'components/BackLink'
import CoursePreview from 'components/CoursePreview'
import CoursePreviewBanner from 'components/CoursePreviewBanner'
import TeachView from 'components/TeachView'
import {
  BannerSpacer,
  Wrapper,
  SiteSelectorK8WrapperDark,
} from './component.styles'
import { DEFAULT_UNIT } from './constants'
import { getData, getCurrentUnit } from './data'
import { TAB_TITLE } from 'containers/Product/constants'
import SiteSelector from 'components/SiteSelector'
import { useHistory } from 'react-router-dom'

const K8TeachComponent = props => {
  const {
    courseLinks,
    match,
    location,
    productName,
    productTabTitle,
    onBacklinkClick,
    onUnitSelect,
    unitSlugs,
    ourClass,
    isTeach,
  } = props
  const history = useHistory()
  const baseUrl = match?.url
  const productTitle = toTitleCase(`${productName?.replace('-', ' ')} Lessons`)
  const tabTitles = {
    page: productTabTitle,
    tab: TAB_TITLE,
  }
  document.title = `${tabTitles?.page} | ${tabTitles?.tab}`

  const doesRouteChange = match?.url
  const unitId = match?.params?.unit
  const courseSlug = match?.params?.course

  // If sent to a page without a unit, a redirect will be triggered to the correct unit
  useEffect(() => {
    if (courseSlug && !unitId) {
      // TODO: Get the correct unit using lms data
      const unit = isTeach ? getCurrentUnit(ourClass, unitSlugs) : DEFAULT_UNIT

      const redirectLink = `${match?.url}/${unit}${location?.search ?? ''}`
      history.replace(redirectLink)
    }
  }, [doesRouteChange])

  const ClassNotFound = <NotFound location={location} match={match} />

  if (unitId && courseSlug) {
    const TopNavigation = (
      <nav className="breadcrumbs">
        <BackLink dataTestId="breadcrumb" onClick={onBacklinkClick}>
          {productTitle}
        </BackLink>
        <SiteSelectorK8WrapperDark>
          <SiteSelector />
        </SiteSelectorK8WrapperDark>
      </nav>
    )

    const selectedCourse = courseLinks?.filter(c => c?.slug === courseSlug)?.[0]

    const handleUnitSelect = unitSlug =>
      onUnitSelect(match?.params?.verb)(courseSlug, unitSlug)

    if (!selectedCourse) {
      return ClassNotFound
    }
    if (isTeach) {
      if (!ourClass) {
        return ClassNotFound
      }

      return (
        <Wrapper>
          {TopNavigation}
          <TeachView
            backlink={TopNavigation}
            getData={getData}
            handleUnitSelect={handleUnitSelect}
            match={match}
            ourClass={ourClass}
            productName={productName}
            selectedCourse={selectedCourse}
            unitId={unitId}
          />
        </Wrapper>
      )
    }

    // We're at the preview route
    return (
      <Wrapper>
        <BannerSpacer />
        <CoursePreviewBanner lessonsLink={baseUrl} />
        {TopNavigation}
        <CoursePreview
          getData={getData}
          match={match}
          onSelectUnit={handleUnitSelect}
          productName={productName}
          unitId={unitId}
        />
      </Wrapper>
    )
  } else {
    return ClassNotFound
  }
}

K8TeachComponent.propTypes = {
  courseLinks: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  isTeach: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string,
    params: PropTypes.shape({
      productName: PropTypes.string,
      verb: PropTypes.string,
      unit: PropTypes.string,
      course: PropTypes.string,
    }),
  }).isRequired,
  onBacklinkClick: PropTypes.func.isRequired,
  onUnitSelect: PropTypes.func.isRequired,
  ourClass: PropTypes.shape({
    instance: PropTypes.string,
    title: PropTypes.string,
    units: PropTypes.array,
  }),
  productName: PropTypes.string,
  productTabTitle: PropTypes.string.isRequired,
  unitSlugs: PropTypes.arrayOf(PropTypes.string),
}

export default K8TeachComponent
